import { ComponentProps } from 'react';

import { OnboardingStepLayout } from '@sorare/gameplay/src/components/onboarding/OnboardingStepLayout';

import { useEnsureProUnlocked } from 'hooks/onboarding/useEnsureProUnlocked';

export const MarketGuidanceLayout = (
  props: ComponentProps<typeof OnboardingStepLayout>
) => {
  useEnsureProUnlocked();
  return <OnboardingStepLayout {...props} />;
};
